import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainAccountComponent } from './main-account.component';
import { ChangeNameComponent } from './model-screens/change-name/change-name.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePhoneComponent } from './model-screens/change-phone/change-phone.component';
import { ActivateTvModalComponent } from './model-screens/activate-tv-modal/activate-tv-modal.component';
import { ChangeLanguageComponent } from './model-screens/change-language/change-language.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { SuccessComponent } from './model-screens/success/success.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { FeedbackComponent } from './model-screens/feedback/feedback.component';
import { ChangePlanComponent } from './model-screens/change-plan/change-plan.component';
import { ChangePaymentInfoComponent } from './model-screens/change-payment-info/change-payment-info.component';
import { NgxStripeModule } from 'ngx-stripe';
import SecureLS from 'secure-ls';
import { CancelSubComponent } from './model-screens/cancel-sub/cancel-sub.component';
import { EditAccountComponent } from './model-screens/edit-account/edit-account.component';
import { RedeemVoucherScreenComponent } from './model-screens/redeem-voucher-screen/redeem-voucher-screen.component';
import { ParentalControlComponent } from './model-screens/parental-control/parental-control.component';
import { ChangeCardInfoComponent } from './model-screens/change-card-info/change-card-info.component';
import { ChangeIdealInfoComponent } from './model-screens/change-ideal-info/change-ideal-info.component';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio'
import { MatSliderModule } from '@angular/material/slider';
//importing the required standalone components
import { AccountCreatedComponent } from 'src/app/shared/components/account-created/account-created.component';
import { ActivateUserComponent } from 'src/app/shared/components/activate-user/activate-user.component';
import { CardPaymentComponent } from 'src/app/shared/components/card-payment/card-payment.component';
import { CardPlanComponent } from 'src/app/shared/components/card-plan/card-plan.component';
import { IdealPaymentBankComponent } from 'src/app/shared/components/ideal-payment-bank/ideal-payment-bank.component';
import { ModelPaymentComponent } from 'src/app/shared/components/model-payment/model-payment.component';
import { PaymentMethodTypeComponent } from 'src/app/shared/components/payment-method-type/payment-method-type.component';
import { PlanInfoComponent } from 'src/app/shared/components/plan-info/plan-info.component';
import { SelectPlanComponent } from 'src/app/shared/components/select-plan/select-plan.component';
import { SignupStepComponent } from 'src/app/shared/components/signup-step/signup-step.component';
import { ChangePasswordComponent } from 'src/app/shared/components/change-password/change-password.component';
import { ManageDevicesComponent } from 'src/app/shared/components/manage-devices/manage-devices.component';
import { DeviceAccordionComponent } from 'src/app/shared/components/device-accordion/device-accordion.component';
import { FooterLinkComponent } from 'src/app/shared/components/footer-link/footer-link.component';
import { GuestHeaderComponent } from 'src/app/shared/components/guest-header/guest-header.component';
import { BillingHistoryComponent } from '../billing-history/billing-history.component';

//Needed for lottie animation.
export function playerFactory() {
  return player;
}

function getstripeKey() {
  const ls = new SecureLS({ isCompression: false });
  let stripeKey: string;
  try {
    stripeKey = ls.get('stripe_key');
  } catch (e) {
    stripeKey = localStorage.getItem('stripe_key');
  }
  return stripeKey;
}


@NgModule({
  declarations: [MainAccountComponent, ChangeNameComponent,
    ChangePhoneComponent, ActivateTvModalComponent, ChangeLanguageComponent, SuccessComponent,
    FeedbackComponent, ChangePlanComponent, ChangePaymentInfoComponent, CancelSubComponent,
    EditAccountComponent, RedeemVoucherScreenComponent,
    ParentalControlComponent, ChangeCardInfoComponent, ChangeIdealInfoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatSliderModule,
    LottieModule.forRoot({ player: playerFactory }),
    NgxStripeModule.forRoot(getstripeKey()),
    AccountCreatedComponent,
    ActivateUserComponent,
    CardPaymentComponent,
    CardPlanComponent,
    IdealPaymentBankComponent,
    ModelPaymentComponent,
    PaymentMethodTypeComponent,
    PlanInfoComponent,
    SelectPlanComponent,
    SignupStepComponent,
    ChangePasswordComponent,
    ManageDevicesComponent,
    DeviceAccordionComponent,
    FooterLinkComponent,
    GuestHeaderComponent,
    BillingHistoryComponent
  ], exports: [ChangePlanComponent, SuccessComponent]
})
export class MainAccountModule { }
